import { relations, sql } from 'drizzle-orm';
import { boolean, index, pgTable, text, uuid } from 'drizzle-orm/pg-core';
import { addresses } from './addresses.js';
import { user } from './auth.js';
import { locations } from './locations.js';
import { timestamps } from './utils/index.js';
import { resourceStatus } from './utils/resource-status.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
export const pharmacies = pgTable('pharmacy', {
    id: uuidv7('id').primaryKey(),
    name: text('name').notNull(),
    code: text('code').notNull().unique(),
    locationId: uuid('location_id')
        .notNull()
        .references(() => locations.id, { onDelete: 'cascade' }),
    email: text('email'),
    phone: text('phone'),
    isSameAddress: boolean('is_same_address').default(true),
    status: resourceStatus('status').default('active'),
    ikNumber: text('ik_number').notNull().unique(),
    producerNumber: text('producer_number'),
    labelName: text('label_name'),
    addressId: uuid('address_id').references(() => addresses.id, { onDelete: 'set null' }),
    deliveryAddressId: uuid('delivery_address_id').references(() => addresses.id, { onDelete: 'set null' }),
    ...timestamps(),
    ...userActions(),
}, t => [
    index('idx_pharmacies_active').on(t.deletedAt).where(sql `${t.deletedAt} IS NULL`),
]);
export const pharmacyRelations = relations(pharmacies, ({ one, many }) => ({
    location: one(locations, {
        fields: [pharmacies.locationId],
        references: [locations.id],
    }),
    address: one(addresses, {
        fields: [pharmacies.addressId],
        references: [addresses.id],
    }),
    deliveryAddress: one(addresses, {
        fields: [pharmacies.deliveryAddressId],
        references: [addresses.id],
    }),
    created: one(user, {
        fields: [pharmacies.createdBy],
        references: [user.id],
    }),
    productionLocations: many(productionLocations),
}));
export const productionLocations = pgTable('production_location', {
    id: uuidv7('id').primaryKey(),
    name: text('name').notNull(),
    pharmacyId: uuid('pharmacy_id')
        .notNull()
        .references(() => pharmacies.id, { onDelete: 'cascade' }),
    status: resourceStatus('status').default('active'),
    ...timestamps(),
    ...userActions(),
}, t => [
    index('idx_production_locations_active').on(t.deletedAt).where(sql `${t.deletedAt} IS NULL`),
]);
export const productionLocationRelations = relations(productionLocations, ({ one }) => ({
    pharmacy: one(pharmacies, {
        fields: [productionLocations.pharmacyId],
        references: [pharmacies.id],
    }),
    created: one(user, {
        fields: [productionLocations.createdBy],
        references: [user.id],
    }),
}));
//# sourceMappingURL=pharmacies.js.map